export default __webpack_public_path__ + "static/media/social-03.36dbb4fc.jpg";